import { useLocation } from 'Pods/Shared/ContextBasedRouter'
import { parseGeneratingRunId } from 'Pods/ThreeDStudio/Hooks/generatingRunUrl'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

/**
 * Whether the user is watching an in-flight run, which is true only on /ai?run=<id>
 * while that run is still going.
 *
 * The URL is the only signal that says which run the user is looking at: it is written
 * when a generation starts and when its library card is clicked, and dropped again by the
 * "Generate New 3D Model" card. A live run alone is not enough - entering the studio
 * through the top navigation lands on bare /ai, the starting screen, and that must stay
 * the starting screen instead of the progress state of a run the user did not open. An
 * in-place enhancement never gets a ?run= URL at all: it reports progress on its own
 * library card ("Processing...") while the enhanced model stays on screen.
 *
 * @returns {boolean}
 */
export default function useIsWatchingGeneratingRun() {
  const location = useLocation()
  const watchedRunId = parseGeneratingRunId(location?.search ?? '')

  // Matched against the in-flight runs so a stale ?run= - a bookmarked or shared URL whose
  // run has since settled - falls back to the starting screen instead of spinning forever.
  return useThreeDStudioStore(state => (
    watchedRunId != null
    && state.generation.activeRuns.some(run => String(run.runId) === String(watchedRunId))
  ))
}
